import { FLAVOUR } from "./serverInfo";


export const API_URL  =
  process.env.REACT_APP_API_URL || FLAVOUR === 'UAE' ? 'https://twigbig.com/api/public/index.php/api/v1' : 'https://us.twigbig.com/api/public/index.php/api/v1';
export const GOOGLE_API_KEY =
  process.env.REACT_APP_GOOGLE_API_KEY ||
  'AIzaSyBnQJSu1PJ5s5FoOinI8ndCEUAyBTmNzTw';

  // https://twigbig.com/dev_api/public/index.php/api/v1
  // https://twigbig.com/api/public/index.php/api/v1